import React from 'react';

import { connect } from 'react-redux';
import { hideSponsoredWarning } from 'services/actions/productsActions';
import { requestRemoveFromCart } from 'services/actions/cartActions';
import { gwpModalDefaultContentStyles } from './GwpModalDefaultContentStyles';

import BaseModal from '../../../shared-components/BaseModal/Modal';
import GwpPopupsContentWrapper from './GwpPopupsContentWrapper';

const RemoveGWPDowngradePopup = (props) => {
  const {
    shouldDisplayRemoveGWPDowngradePopup,
    hideSponsoredWarning,
    requestRemoveFromCart,
  } = props;

  return (
    <BaseModal
      showCloseIcon={false}
      isOpen={shouldDisplayRemoveGWPDowngradePopup}
      onRequestClose={hideSponsoredWarning}
      shouldCloseOnOverlayClick
      styles={gwpModalDefaultContentStyles}
    >
      <GwpPopupsContentWrapper
        title="Are You Sure You Want to Remove This Product?"
        description="Deleting this item will downgrade your mystery gift."
        requestRemoveFromCart={requestRemoveFromCart}
        hideSponsoredWarning={hideSponsoredWarning}
      />
    </BaseModal>
  );
};

function mapStateToProps(state) {
  return {
    shouldDisplayRemoveGWPDowngradePopup:
      state.productsState.shouldDisplayRemoveGWPDowngradePopup,
  };
}

export default connect(mapStateToProps, {
  hideSponsoredWarning,
  requestRemoveFromCart,
})(RemoveGWPDowngradePopup);
